import { ILineItem } from '../models/common';

export const isProductTypeEPPOnly = (lineItems: ILineItem[]): boolean => {
  const hdppItems = lineItems.filter((item) => item.productType === 'EPP');
  return hdppItems.length === 1 && lineItems.length === 1;
};
